"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _variables = require("../../../../global-files/variables");

var _templateObject;

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n  background: #f9f9f9;\n  padding: 12px 15px;\n  //overflow: auto;\n  //border: 1px solid red;\n\n  .logoCompany {\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    overflow: hidden;\n\n    .icon-logoCompany {\n      padding: 5px;\n    }\n  }\n\n  .title {\n    flex-grow: 2;\n    min-width: min-content;\n    text-align: left;\n    font-family: ", ", sans-serif;\n    font-size: 15px;\n    color: #262626;\n  }\n\n  .btn-chooseChat,\n  .icon-chooseChat {\n    width: 24px;\n    height: 24px;\n    padding: 0px;\n  }\n\n  .btn-X {\n    width: 24px;\n    height: 24px;\n    padding: 0px;\n  }\n"])), _variables.FontFamily.RobotoMedium);

exports.Container = Container;